<template>
    <div v-if="showStep" class="step-card-wrapper">
        <generic-step-card
            :title="stepTitle"
            :current-step-name="currentStepName"
            :step="step"
            :is-preview="isPreview"
            :is-brief-accepted="isBriefAccepted"
            :is-brief-editable="isBriefEditable"
            :brief="brief"
        >
            <div v-if="contact.primary_address" slot="details" class="left-indent">
                <g-address :address="contact.primary_address" :show-email="false" :show-phone="false" class="address" />
            </div>
        </generic-step-card>
    </div>
</template>

<script>
    import GenericStepCard from '../GenericStepCard';
    import {NAME_SHIPPING_INFO} from '../../../../../constants/activation-brief-steps';
    import StepCardViewMixin from '../mixins/StepCardViewMixin';

    export default {
        name:       'ShippingInfoStepCardView',
        components: {
            GenericStepCard,
        },
        mixins: [
            StepCardViewMixin,
        ],
        props: {
            contact: {
                type:     Object,
                required: true,
            },
        },
        computed: {
            stepName() {
                return NAME_SHIPPING_INFO;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .step-card-wrapper {
        margin-bottom: $g-spacing-5;
    }
    .address {
        line-height: 1.5;
        font-size: $g-font-size-small;
    }
    .left-indent {
        margin-left: $g-spacing-7;
    }
</style>
